// Constants shared across javascript files. Define them here
export const HOSPICE_SECTIONS_CHECKBOX_FIELDS = [
  { key: "Hygiene", value: "Hygiene", label: "Hygiene" },
  { key: "Additional Hygiene", value: "Additional Hygiene", label: "Additional Hygiene" },
  { key: "Mobility", value: "Mobility", label: "Mobility" },
  { key: "Cognition", value: "Cognition", label: "Cognition" },
  { key: "Nutrition", value: "Nutrition", label: "Nutrition" },
  { key: "Elimination", value: "Elimination", label: "Elimination" },
  { key: "Cardio/Resp", value: "Cardio/Resp", label: "Cardio/Resp" },
  { key: "Skin", value: "Skin", label: "Skin" },
  { key: "General", value: "General", label: "General" }
];

export const SHIFT_LOG_TASK_FIELDS = [
  { key: "bed_checks", value: "bed_checks", label: "Bed Checks", textKey: "bed_checks_text" },
  {
    key: "bed_linen_change",
    value: "bed_linen_change",
    label: "Bed Linen Change/Laundry",
    textKey: "bed_linen_change_text"
  },
  {
    key: "clothing_change",
    value: "clothing_change",
    label: "Clothing Change",
    textKey: "clothing_change_text"
  },
  { key: "foot_care", value: "foot_care", label: "Foot Care/Bath", textKey: "foot_care_text" },
  { key: "goods", value: "goods", label: "Goods Distribution", textKey: "goods_text" },
  { key: "hair_cut", value: "hair_cut", label: "Hair Cut", textKey: "hair_cut_text" },
  { key: "hair_wash", value: "hair_wash", label: "Hair Wash", textKey: "hair_wash_text" },
  { key: "laundry", value: "laundry", label: "Laundry", textKey: "laundry_text" }, // TODO should we remove laundry because we added ben linen change
  {
    key: "meal_prep",
    value: "meal_prep",
    label: "Meal Prep/Meal Given",
    textKey: "meal_prep_text"
  },
  { key: "medication", value: "medication", label: "Medication", textKey: "medication_text" },
  { key: "nail_care", value: "nail_care", label: "Nail Care", textKey: "nail_care_text" },
  { key: "peri_care", value: "peri_care", label: "Peri Care", textKey: "peri_care_text" },
  {
    key: "personal_care",
    value: "personal_care",
    label: "Personal Care",
    textKey: "personal_care_text"
  },
  { key: "pnrs_given", value: "pnrs_given", label: "PNR's Given", textKey: "pnrs_given_text" },
  {
    key: "room_cleaning",
    value: "room_cleaning",
    label: "Room Cleaning",
    textKey: "room_cleaning_text"
  },
  { key: "shave", value: "shave", label: "Shave", textKey: "shave_text" },
  { key: "shower", value: "shower", label: "Shower", textKey: "shower_text" },
  { key: "vitals", value: "vitals", label: "Vitals", textKey: "vitals_text" },
  { key: "wound_care", value: "wound_care", label: "Wound Care", textKey: "wound_care_text" }
];

export const getShiftLogTaskLabelByKey = (key) => {
  const shiftLogToGet = SHIFT_LOG_TASK_FIELDS.find(
    (shift_log_task) => shift_log_task.value === key
  );
  const hospiceShiftLog = HOSPICE_SECTIONS_CHECKBOX_FIELDS.find(
    (shift_log_task) => shift_log_task.value === key
  );
  if (!shiftLogToGet && !hospiceShiftLog)
    return { value: "error", label: "error", textKey: "error" };
  if (shiftLogToGet) return shiftLogToGet;
  if (hospiceShiftLog) return hospiceShiftLog;
};
